import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function CommentEditor({ comment, onChange }) {
  const c = comment || { enabled: false, required: false, trigger: "always", label: "", placeholder: "" };

  return (
    <div className="border-t border-black/10 pt-3 space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-[10px] uppercase tracking-widest text-[#525252]">Comment box</Label>
        <Switch
          checked={Boolean(c.enabled)}
          onCheckedChange={(checked) => onChange({ ...c, enabled: checked })}
        />
      </div>
      {c.enabled && (
        <>
          <Select value={c.trigger || "always"} onValueChange={(val) => onChange({ ...c, trigger: val })}>
            <SelectTrigger className="h-8 rounded-none border-black/15 text-xs">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="rounded-none">
              <SelectItem value="yes">Show on Yes</SelectItem>
              <SelectItem value="no">Show on No</SelectItem>
              <SelectItem value="always">Always show</SelectItem>
            </SelectContent>
          </Select>
          <Input
            placeholder="Comment label"
            value={c.label || ""}
            onChange={(e) => onChange({ ...c, label: e.target.value })}
            className="h-8 rounded-none border-black/20 bg-transparent text-sm"
          />
          <Input
            placeholder="Comment placeholder (optional)"
            value={c.placeholder || ""}
            onChange={(e) => onChange({ ...c, placeholder: e.target.value })}
            className="h-8 rounded-none border-black/20 bg-transparent text-sm"
          />
          <div className="flex items-center justify-between">
            <Label className="text-[10px] uppercase tracking-widest text-[#525252]">Comment required</Label>
            <Switch
              checked={Boolean(c.required)}
              onCheckedChange={(checked) => onChange({ ...c, required: checked })}
            />
          </div>
        </>
      )}
    </div>
  );
}
